import BaseOptionsBundle from "%/dynamic-component-editor/classes/base-options";
import FontColor from "%/dynamic-component-editor/options/font-color";
import FontSize from "%/dynamic-component-editor/options/font-size";
import FontWeight from "%/dynamic-component-editor/options/font-weight";
import FontFamily from "%/dynamic-component-editor/options/font-family";
import { inspectorTools } from "%/dynamic-component-editor/inspector/inspector-tool-map";
import BaseOption from "%/dynamic-component-editor/classes/base-option";

export default class BasicTextOptions extends BaseOptionsBundle {

  optionTitle = "Basic Typography";
  static optionClassName = "i-dynamic-text";
  inspectorToolGroup = "basic-text";
  useInspectorLabel = false;

  static userInterfaceComponent = {
    component: inspectorTools.BASIC_TEXT_TOOL_SET,
    canSetOtherStates: [BaseOption.$states.HOVER],
  };

  constructor(values = {}, hideFromInspector = {}) {
    const option = function (OptionClass, key) {
      if (hideFromInspector[key]) {
        return new OptionClass(undefined, true);
      }
      return OptionClass;
    };
    super(values, [
      option(FontFamily, "font-family"),
      option(FontColor, "font-color"),
      option(FontSize, "font-size"),
      option(FontWeight, "font-weight"),
    ]);
  }
}
